
import { Vue, Component, Watch, Model } from 'vue-property-decorator';
import AuditService from '@/services/audit.service';
import lazyInject from '@/di';
import UserService from '@/services/user.service';
import ShopService from '@/services/shop.service';

@Component({})
export default class KaIDField extends Vue {
  val: any = '';

  treeData: any = [];

  kalist: any = [];

  @lazyInject(UserService)
  userService!: UserService;

  @lazyInject(ShopService)
  shopService!: ShopService;

  @lazyInject(AuditService)
  protected auditService!: AuditService;

  @Model('change')
  value!: any;

  @Watch('val')
  watchInternalVal() {
    this.$emit('change', this.val);
    if (!this.val) {
      this.$emit('updateSubmittable', false);
    } else {
      this.$emit('updateSubmittable', true);
    }
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = Number(this.value);
    } else {
      this.val = undefined;
    }
  }

  changeVal(e: any) {
    this.val = e;
  }

  mounted() {
    this.watchValue();
    // this.$emit('updateSubmittable', true);
    this.getKaList();
  }

  async getKaList() {
    const id = this.userService.currentUser()?.id;
    const response = await this.shopService.postKaUserList(id);
    if (response) {
      this.kalist = response;
    }
  }
}
